export default {
    data() {
        return {
            validationRefresh: true
        };
    },
    methods: {
        handleValidationData(response, formData) {
            if (response.json.validation) {
                this.cleanValidationData(formData);
                if (Array.isArray(formData)) {
                    for (const validationKey in response.json.validation) {
                        const validationIndex = formData.findIndex(
                            item => item.key === validationKey
                        );
                        formData[validationIndex].valid = false;
                        formData[validationIndex].invalidFeedback = "";
                        response.json.validation[validationKey].forEach(
                            feedback => {
                                if (
                                    formData[validationIndex]
                                        .invalidFeedback !== ""
                                ) {
                                    formData[validationIndex].invalidFeedback +=
                                        ", ";
                                }
                                formData[
                                    validationIndex
                                ].invalidFeedback += feedback;
                            }
                        );
                    }
                } else {
                    for (const validationKey in response.json.validation) {
                        if (formData[validationKey]) {
                            formData[validationKey].valid = false;
                            formData[validationKey].invalidFeedback = "";
                            response.json.validation[validationKey].forEach(
                                feedback => {
                                    if (
                                        formData[validationKey]
                                            .invalidFeedback !== ""
                                    ) {
                                        formData[
                                            validationKey
                                        ].invalidFeedback += ", ";
                                    }
                                    formData[
                                        validationKey
                                    ].invalidFeedback += feedback;
                                }
                            );
                        }
                    }
                }

                this.validationRefresh = !this.validationRefresh;
            }
        },
        cleanValidationData(formData) {
            if (Array.isArray(formData)) {
                formData = formData.map(item => {
                    item.valid = null;
                    item.invalidFeedback = null;
                    return item;
                });
            } else {
                Object.entries(formData).map(([key, obj]) => {
                    obj.valid = null;
                    obj.invalidFeedback = null;
                    formData[key] = obj;
                });
            }
        }
    }
};
